import React from 'react';
import { connect } from 'react-redux';
import { resetConfig, loadConfig } from '../../../../helpers/configuration/actions';

class F_3 extends React.Component {
    constructor(props) {
        super(props);

        this.gotoNextStep = this.gotoNextStep.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
    }

    gotoNextStep(e) {
        e.preventDefault();

        resetConfig();
        loadConfig({ config: { defaultView: 'click2call', temporary: true } });
        this.props.saveValues({ reinvite: true });
        this.props.nextStep(e.target.dataset['next']);
    }

    onFieldChange(e) {
        const name = e.target.name;
        this.props.saveValues({
            [name]: e.target.value,
            categoryLine: null,
            categorySegment: null,
            msisdn: null,
            issid: null
        });
    }

    render() {
        return (
            <div className="click2call--groups">
                <div className="click2call--group click2call--group-label">
                    <p>Wpisz numer telefonu, ID Neostrady lub inne usługi.</p>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-input">
                        <input
                            className={this.props.validate.userIdentificationNumber ? '' : 'error'}
                            type="tel"
                            onChange={this.onFieldChange}
                            name="userIdentificationNumber"
                            autoComplete="off"
                            autoFocus={true}
                            maxLength="14"
                        />
                    </div>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-next">
                        <button
                            onClick={this.gotoNextStep}
                            disabled={!this.props.validate.form}
                            data-next="F_4"
                        >
                            Dalej
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const validateUserIdentificationNumber = userIdentificationNumber => {
    if (userIdentificationNumber && userIdentificationNumber.length === 9) {
        // PhoneNumber (9)
        const num = parseInt(userIdentificationNumber, 10) || 0;
        if (
            num < 100000000 || // must start with 1
            num >= 990000000 || // exclude public services 99x
            (num >= 190000000 && num < 200000000) || // exclude 19xxx AUS
            (num >= 112000000 && num < 113000000) || // exclude 112 help number
            (num >= 800000000 && num < 810000000) || // exclude free infolines 80x
            (num >= 700000000 && num < 710000000) // exclude premium numbers, 70x
        ) {
            return false;
        }
        return true;
    } else if (
        userIdentificationNumber &&
        (userIdentificationNumber.length === 12 || userIdentificationNumber.length === 14)
    ) {
        // NEO_ID (12) or IDSL_ID (14)
        return true;
    }
    return false;
};

const validate = state => {
    if (!validateUserIdentificationNumber(state.call.registration.userIdentificationNumber))
        return false;
    return true;
};

const mapStateToProps = state => {
    return {
        call: state.call,
        validate: {
            userIdentificationNumber: validateUserIdentificationNumber(
                state.call.registration.userIdentificationNumber
            ),
            form: validate(state)
        }
    };
};

export default connect(mapStateToProps)(F_3);
